import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wordLineBreak'
})
export class WordLineBreakPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    return value
      .split(/(<[^>]+>)/g)
      .map(part => (part.startsWith('<') ? part : part.split(/\s+/).filter(w => w).join('<br>')))
      .join('');
  }
}
